var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"gift-coupon",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"title"},[_vm._v("包含赠品")]),_vm._v(" "),_c('div',{staticClass:"coupon-box"},[_c('div',{staticClass:"name"},[_vm._v("卡券")]),_vm._v(" "),_c('span',{staticClass:"count"},[_vm._v("x"+_vm._s(_vm.count))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }